import { TextureData } from "../../types/types";
import { Padding } from "../../utils/Padding";
import { TextBubble } from "./TextBubble";


export class HintBubble 
    extends TextBubble
{
    protected facing: Phaser.Geom.Point;
    protected contentGrowthX: number;

    private CONTENTGROWTHX_OFFSET: number = 40;
    private facingUp = new Phaser.Geom.Point(0, -1);
    private facingDown = new Phaser.Geom.Point(0, 1);
    private facingLeft = new Phaser.Geom.Point(-1, 0);
    private facingRight = new Phaser.Geom.Point(1, 0);
    
    public GetFacing(): Phaser.Geom.Point
    {
        return this.facing;
    }

    public SetFacingGrowingDown(updateView: boolean = false): void {
        this.SetFacingAndGrowthDirection(this.facingDown, 0, updateView);
    }

    public SetFacingGrowingUp(updateView: boolean = false): void {
        this.SetFacingAndGrowthDirection(this.facingUp, 0, updateView);
    }

    public SetFacingGrowingLeft(updateView: boolean = false): void {
        this.SetFacingAndGrowthDirection(this.facingLeft, -1, updateView);
    }

    public SetFacingGrowingRight(updateView: boolean = false): void {
        this.SetFacingAndGrowthDirection(this.facingRight, 1, updateView);
    }

    public SetFacingAndGrowthDirection(
        facing: Phaser.Geom.Point, 
        contentGrowthX: number, 
        updateView: boolean = false
    ): void
    {
        this.facing = facing;
        this.contentGrowthX = contentGrowthX;

        if (updateView) {
            this.UpdateView();
        }
    }
    
    public override UpdateView(): void
    {
        // console.log(this.facing, this.contentGrowthX);
        
        // reimplement updateview from scratch
        // super.UpdateView();

        // calculate content size
        this.contentSize.Set(
            this.padding.left + this.txtLabel.displayWidth + this.padding.right,
            this.padding.top + this.txtLabel.displayHeight + this.padding.bottom,
        );

        // calculate total size (content size plus embedded bg effects)
        this.totalSize.Set(
            this.bgEffectsPadding.left + this.contentSize.width + this.bgEffectsPadding.right,
            this.bgEffectsPadding.top + this.contentSize.height + this.bgEffectsPadding.bottom,
        );

        // set bg size
        this.bg.setSize(this.totalSize.width, this.totalSize.height);

        /*
        Special case, where bubble grows vertically, but content is NOT center-aligned, only partially.
        Example: East:
            speechBubble: {
                portrait: {
                    facing: new Phaser.Geom.Point(0, -1),
                    contentGrowthX: -1,
                },
        */
        // Use facing and contentGrowthX to position/align content around container's (0,0) 
        // NOTE: bg is a nineslice
        // NOTE: bg origin is always middle (0.5, 0.5)
        // NOTE: bgTip visual: ">" (right facing tip); bgTip.originX/Y always (0.5, 0.5)
        // from right to left
        // this.bg.visible = false;
        // FACING X
        if (this.facing.x === -1) {
            this.bgTip.angle = 0;
            this.bgTip.setPosition(-this.bgTip.displayWidth * 0.5, 0);
            this.bg.setPosition(-this.bgTip.displayWidth - this.contentSize.width * 0.5, 0);
        }
        else if (this.facing.x === 1) {
            this.bgTip.angle = 180;
            this.bgTip.setPosition(this.bgTip.displayWidth * 0.5, 0);
            this.bg.setPosition(this.bgTip.displayWidth + this.contentSize.width * 0.5, 0);
        }
        
        // FACING Y
        if (this.facing.y === -1) {
            this.bgTip.angle = 90;
            this.bgTip.setPosition(0, -this.bgTip.displayHeight * 0.5);
            if (this.contentGrowthX == -1) {
                const halfContentWidth = Math.max(this.contentSize.width * 0.5, 40);
                this.bg.setPosition(-halfContentWidth + this.CONTENTGROWTHX_OFFSET, -this.bgTip.displayHeight - this.contentSize.height * 0.5);
            }
            else if (this.contentGrowthX === 1) {
                const halfContentWidth = Math.max(this.contentSize.width * 0.5, 40);
                this.bg.setPosition(halfContentWidth - this.CONTENTGROWTHX_OFFSET, -this.bgTip.displayHeight - this.contentSize.height * 0.5);
            }
            else { // 0
                this.bg.setPosition(0, -this.bgTip.displayHeight - this.contentSize.height * 0.5);
            }
        }
        else if (this.facing.y === 1) {
            this.bgTip.angle = 270;
            this.bgTip.setPosition(0, this.bgTip.displayHeight * 0.5);
            if (this.contentGrowthX == -1) {
                const halfContentWidth = Math.max(this.contentSize.width * 0.5, 40);
                this.bg.setPosition(-halfContentWidth + this.CONTENTGROWTHX_OFFSET, this.bgTip.displayHeight + this.contentSize.height * 0.5);
            }
            else if (this.contentGrowthX == 1) {
                const halfContentWidth = Math.max(this.contentSize.width * 0.5, 40);
                this.bg.setPosition(halfContentWidth - this.CONTENTGROWTHX_OFFSET, this.bgTip.displayHeight + this.contentSize.height * 0.5);
            }
            else { // 0
                this.bg.setPosition(0, this.bgTip.displayHeight + this.contentSize.height * 0.5);
            }
        }
        
        // reposition inner content
        // txtLabel
        this.txtLabel.setPosition(
            this.bg.x - this.contentSize.width * 0.5 + this.padding.left + this.txtLabel.displayWidth * 0.5, 
            this.bg.y,
        );
    }
}